import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {action, observable, makeObservable} from 'mobx';
import {inject, observer} from 'mobx-react';
import {styleable} from 'decorators';
import {injectIntl} from 'react-intl';

import {StepNumberMobile as StepNumber} from 'components/StepNumber';
import ReportIssueButton from 'components/StepCheckToolbar/Escalation/Button';
import DispatchButton from 'components/StepCheckToolbar/Dispatch/Button';

import {getChecklistFromLocalStorage} from 'utils/checklist-utils';

import Toolbar from './Toolbar';
import {Left, Right, StepCard, StepContent, StepMedia, StepSlide} from './styles';

@inject('store')
@observer
@styleable
class StepCardComponent extends Component {
  static defaultProps = {
    shouldShowSpinnerWhileLoading: true,
    noteContentKey: 'contentHtml',
    isCheck: false
  };

  static propTypes = {
    shouldShowSpinnerWhileLoading: PropTypes.bool,
    noteContentKey: PropTypes.oneOf(['content', 'contentHtml']).isRequired,
    isCheck: PropTypes.bool
  };

  @observable hintImageUrl = null;
  @observable hintMetadata = null;

  componentDidMount = () => {
    const {isCheck} = this.props;

    if (isCheck) {
      const {
        store: {
          instructionPage: {
            currentInstruction: {id: instructionId}
          },
          checklist: {setChecklist}
        }
      } = this.props;

      const checklist = getChecklistFromLocalStorage(instructionId);
      setChecklist(checklist);
    }
  };

  constructor(props) {
    super(props);
    makeObservable(this);
  }

  render() {
    const {
      autoplayVideo,
      content,
      imageSizes,
      media,
      onClickMedia,
      orientation,
      refreshMedia,
      shouldShowSpinnerWhileLoading,
      step,
      noteContentKey,
      store,
      isCurrent,
      isCheck,
      stepIndex,
      checklistTemplate,
      footer
    } = this.props;
    const {
      platform: {
        canUseMediaInStepHints,
        hasChecklistEscalation,
        hasDispatchSite,
        hasDispatchEnabled,
        developmentFeatureFlags: {dispatch}
      },
      instructionPage
    } = store;
    const {number = step.position + 1, instructionHtml, notes} = step;
    const hasAlertRecipients = instructionPage?.currentInstruction?.hasAlertRecipients;

    const imageUrl = canUseMediaInStepHints && this.hintImageUrl ? this.hintImageUrl : step.imageUrl;
    const metadata =
      canUseMediaInStepHints && this.hintImageUrl
        ? this.hintMetadata
        : step.metadata
        ? step.metadata
        : step.media?.metadata
        ? step.media.metadata
        : {};

    const hasDispatchButton = dispatch && hasDispatchSite && hasDispatchEnabled && isCheck;
    const hasReportButton = !hasDispatchButton && (hasChecklistEscalation || hasAlertRecipients) && isCheck;

    return (
      <StepSlide data-cy="step-card" hasReportButton={hasReportButton}>
        {hasReportButton && <ReportIssueButton stepIndex={stepIndex} isMobile />}
        {hasDispatchButton && <DispatchButton stepIndex={stepIndex} isMobile />}

        <StepCard orientation={orientation}>
          <Left>
            {content || (
              <StepContent
                dangerouslySetInnerHTML={{__html: instructionHtml}}
                isCompact={false}
                isResponsive={true}
                isScrollable={true}
                footer={footer}
              />
            )}
            {!isCheck && (
              <Toolbar
                onCloseHint={this.handleCloseHint}
                onOpenHint={this.handleOpenHint}
                notes={notes}
                noteContentKey={noteContentKey}
                isCurrent={isCurrent}
                checklistTemplate={checklistTemplate}
              />
            )}
          </Left>
          <Right orientation={orientation}>
            {media || (
              <StepMedia
                mediaUrl={imageUrl}
                imageSizes={imageSizes}
                autoplayVideo={autoplayVideo}
                refresh={refreshMedia}
                onClickMedia={onClickMedia}
                metadata={metadata}
                shouldShowSpinnerWhileLoading={shouldShowSpinnerWhileLoading}
              />
            )}{' '}
          </Right>
        </StepCard>
        <StepNumber number={number} />
      </StepSlide>
    );
  }

  @action
  handleCloseHint = event => {
    const {onCloseHint} = this.props;

    this.hintImageUrl = null;
    this.hintMetadata = null;

    if (typeof onCloseHint === 'function') {
      onCloseHint(event);
    }
  };

  @action
  handleOpenHint = event => {
    const {onOpenHint} = this.props;

    this.hintImageUrl = event.selectedImageUrl;
    this.hintMetadata = event.selectedMetadata;

    if (typeof onOpenHint === 'function') {
      onOpenHint(event);
    }
  };
}

export default injectIntl(StepCardComponent);
